// src/swUpdate.ts
//
// One-bit external store for "a new build is waiting to be applied".
//
// WHY A STORE AND NOT A PROP
// --------------------------
// The service worker registers outside the React tree (on window "load", see
// src/serviceWorkerRegistration.ts), so the signal originates in index.tsx.
// The consumer is the sidebar footer, which lives in AppShell — rendered from
// two call sites inside App. Threading a prop from the root through App into
// both AppShell renders touches five places in a ~6900-line component to carry
// a single boolean, so it goes through here instead.
//
// The flag is one-way: once an update is waiting it stays waiting until the
// user applies it and the page reloads.

type Listener = () => void;

let updateReady = false;
const listeners = new Set<Listener>();

/** Called by index.tsx when the SW reports a new build parked in "waiting". */
export function markSwUpdateReady() {
  if (updateReady) return;
  updateReady = true;
  listeners.forEach((fn) => fn());
}

function subscribe(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

function getSnapshot(): boolean {
  return updateReady;
}

export { subscribe as subscribeSwUpdate, getSnapshot as getSwUpdateReady };
